"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { useRouter } from "next/navigation";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import PlayButton from "../ui/playbutton";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export default function VerticalBigVideoCategoryNews(t0) {
  const $ = _c(63);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "VIDEOS",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const category = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "\u0B92\u0B9F\u0BBF\u0B9A\u0BBE\u0BB5\u0BBF\u0BA9\u0BCD \u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BA8\u0BCD\u0BA4\u0BA4\u0BC1 238 \u0BAA\u0BC7\u0BB0\u0BCD \u0B95\u0BCA\u0BB2\u0BCD\u0BB2\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA9\u0BB0\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD 900 \u0BAA\u0BC7\u0BB0\u0BCD \u0B95\u0BBE\u0BAF\u0BAE\u0B9F\u0BC8\u0BA8\u0BCD\u0BA4\u0BA9\u0BB0\u0BCD",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const title = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "\"\u0B8E\u0BA3\u0BCD\u0B9F\u0BB0\u0BBF\u0B9E\u0BB0\u0BCD \u0BA4\u0BBF \u0BAA\u0BBF\u0BB0\u0BAE\u0BC8\", \u0BA8\u0BBE\u0BB5\u0BB2\u0BCD, \u0B85\u0BAA\u0BBF\u0BAE\u0BA9\u0BCD\u0BAF\u0BC1 '\u0B9A\u0B95\u0BCD\u0BB0\u0BB5\u0BCD\u0BAF\u0BC2' \u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0BAA\u0BBF\u0BB0\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD \u0BA8\u0BC1\u0BB4\u0BC8\u0BB5\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BCA\u0B9F\u0BB0\u0BCD\u0BAA\u0BC1\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF, 15 \u0BB5\u0BAF\u0BA4\u0BC1 \u0B9A\u0BBF\u0BB1\u0BC1\u0BB5\u0BA9\u0BCD \u0BA4\u0BA9\u0BA4\u0BC1 \u0BAA\u0BBE\u0BB2\u0BC1\u0BA3\u0BB0\u0BCD\u0BB5\u0BC8\u0B95\u0BCD \u0B95\u0BA3\u0BCD\u0B9F\u0BB1\u0BBF\u0BAF\u0BC1\u0BAE\u0BCD \u0BB5\u0BAF\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BB5\u0BB0\u0BC1\u0BAE\u0BCD \u0B95\u0BA4\u0BC8\u0BAF\u0BBE\u0B95\u0BC1\u0BAE\u0BCD.",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const excerpt = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: "15 min ago",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const timeAgo = t9;
  let t10;
  if ($[8] !== t5) {
    t10 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrc = t10;
  const router = useRouter();
  const categoryValue = category?.value || "";
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t11 = timeAgo?.value;
  let t12;
  if ($[10] !== t11) {
    t12 = getTimeAgo(t11);
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const timeAgoValue = t12;
  let t13;
  if ($[12] !== imageSrc?.value) {
    t13 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[12] = imageSrc?.value;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const imageSrcValue = t13;
  let t14;
  if ($[14] !== sectionUrl) {
    t14 = getSectionUrl(sectionUrl);
    $[14] = sectionUrl;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const sectionUrlValue = t14;
  let t15;
  if ($[16] !== router || $[17] !== sectionUrlValue) {
    t15 = e => {
      if (sectionUrlValue) {
        e.preventDefault();
        e.stopPropagation();
        router.push(sectionUrlValue);
      }
    };
    $[16] = router;
    $[17] = sectionUrlValue;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const handleCategoryClick = t15;
  let t16;
  if ($[19] !== imageMetadata || $[20] !== imageSrc?.customClass || $[21] !== imageSrc?.hidden || $[22] !== imageSrcValue || $[23] !== titleValue) {
    t16 = !imageSrc?.hidden && <div className={imageSrc?.customClass || ""}><div className="relative w-full aspect-[16/9] overflow-hidden"><div className="absolute bottom-2 right-2 z-10"><PlayButton /></div><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 400px" className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[19] = imageMetadata;
    $[20] = imageSrc?.customClass;
    $[21] = imageSrc?.hidden;
    $[22] = imageSrcValue;
    $[23] = titleValue;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== category?.customClass || $[26] !== category?.hidden || $[27] !== categoryValue || $[28] !== handleCategoryClick || $[29] !== sectionUrlValue) {
    t17 = !category?.hidden && (sectionUrlValue ? <span className={`text-14-tamil-600 text-012061 tracking-wide uppercase hover:underline cursor-pointer ${category?.customClass || ""}`} onClick={handleCategoryClick}>{categoryValue}</span> : <div className={`text-14-tamil-600 text-012061 tracking-wide uppercase ${category?.customClass || ""}`}>{categoryValue}</div>);
    $[25] = category?.customClass;
    $[26] = category?.hidden;
    $[27] = categoryValue;
    $[28] = handleCategoryClick;
    $[29] = sectionUrlValue;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== title?.customClass || $[32] !== title?.hidden || $[33] !== titleValue) {
    t18 = !title?.hidden && <h3 className={`text-012061 text-24-tamil-700 md:text-16-tamil-700 leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[31] = title?.customClass;
    $[32] = title?.hidden;
    $[33] = titleValue;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== excerpt?.customClass || $[36] !== excerpt?.hidden || $[37] !== excerptValue) {
    t19 = !excerpt?.hidden && <p className={`text-16-tamil-400 text-020202 leading-[1.4] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[35] = excerpt?.customClass;
    $[36] = excerpt?.hidden;
    $[37] = excerptValue;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== timeAgo?.customClass || $[40] !== timeAgo?.hidden || $[41] !== timeAgoValue) {
    t20 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[39] = timeAgo?.customClass;
    $[40] = timeAgo?.hidden;
    $[41] = timeAgoValue;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = slug ? `/${slug}` : undefined;
  let t22;
  if ($[43] !== excerptValue || $[44] !== imageSrcValue || $[45] !== slug || $[46] !== t21 || $[47] !== titleValue) {
    t22 = <div className="flex gap-3"><MessageIcon id="message-icon-3" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t21} /></div>;
    $[43] = excerptValue;
    $[44] = imageSrcValue;
    $[45] = slug;
    $[46] = t21;
    $[47] = titleValue;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t20 || $[50] !== t22) {
    t23 = <div className="flex justify-between items-center gap-2">{t20}{t22}</div>;
    $[49] = t20;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t17 || $[53] !== t18 || $[54] !== t19 || $[55] !== t23) {
    t24 = <div className="flex flex-col gap-2">{t17}{t18}{t19}{t23}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t16 || $[58] !== t24) {
    t25 = <article className="flex flex-col overflow-hidden p-4 gap-4">{t16}{t24}</article>;
    $[57] = t16;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  const content = t25;
  if (slug) {
    const t26 = `/${slug}`;
    let t27;
    if ($[60] !== content || $[61] !== t26) {
      t27 = <Link href={t26} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[60] = content;
      $[61] = t26;
      $[62] = t27;
    } else {
      t27 = $[62];
    }
    return t27;
  }
  return content;
}